var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      ref: "inviteUserModal",
      attrs: {
        showCloseBtn: true,
        afterCloseModal: _vm.afterCloseModal,
        modalType: "medium-modal",
      },
    },
    [
      _c("div", { attrs: { slot: "modal-header" }, slot: "modal-header" }, [
        _c("p", {
          staticClass: "title",
          domProps: { innerHTML: _vm._s(_vm.title) },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "content" }, slot: "content" },
        [
          _vm._t("content", function () {
            return [
              _c("label", { staticClass: "text font-bold" }, [
                _vm._v(_vm._s(_vm.$t("user.usernameEmailAddress"))),
              ]),
              _vm._v(" "),
              _c("HKLSelect", {
                ref: "multiSelect",
                attrs: {
                  value: _vm.value,
                  options: _vm.hklOptions,
                  showSearch: true,
                  placeholder: "",
                },
                on: { change: _vm.addUserById },
              }),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("SimpleTable", {
                    ref: "usersToBeInvited",
                    staticClass: "simple-table",
                    attrs: {
                      removable: true,
                      headers: _vm.candidateTableHeaders,
                    },
                    on: { removeRow: _vm.removeUser },
                  }),
                ],
                1
              ),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
        _c(
          "button",
          {
            staticClass: "btn btn--darkblue",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.cancel()
              },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.cancelBtnName) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn--orange",
            attrs: {
              type: "button",
              disabled: _vm.scopedCandidates.length === _vm.candidates.length,
            },
            on: {
              click: function ($event) {
                return _vm.invite()
              },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.inviteBtnName) + "\n    ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }